import { Link } from 'react-router-dom';

import { cn } from '@/shared/shadcn/lib/utils';

import { PATH } from '@/shared/constants';

interface LegalLinksProps {
  className?: string;
}

/** 이용약관 / 개인정보처리방침 링크 (개인정보처리방침은 법적으로 구분되어 보여야 해서 굵게 표시) */
export default function LegalLinks({ className }: LegalLinksProps) {
  return (
    <nav aria-label='약관 및 정책' className={cn('flex items-center justify-center gap-3 text-xs text-gray-700', className)}>
      <Link to={PATH.PUBLIC.TERMS} className='hover:underline'>
        이용약관
      </Link>
      <span aria-hidden='true' className='h-3 w-px bg-gray-300' />
      <Link to={PATH.PUBLIC.PRIVACY} className='font-semibold hover:underline'>
        개인정보처리방침
      </Link>
      <span aria-hidden='true' className='h-3 w-px bg-gray-300' />
      <Link to={PATH.PUBLIC.SUPPORT} className='font-semibold hover:underline'>
        고객지원
      </Link>
      <span aria-hidden='true' className='h-3 w-px bg-gray-300' />
      <Link to={PATH.PUBLIC.ZOOM} className='font-semibold hover:underline'>
        Zoom 연동 안내
      </Link>
    </nav>
  );
}
